import { axios, axiosNT } from "helper/axios";
import { localStore } from "stores/localStorage";
import { masterConstants } from "./masterConstants";
import { config } from "config/index";

const masterApis = {};

masterApis.getRMSRiskAssessmentQuestions = () => {
  return axios.get(masterConstants.RMS_RISK_ASSESSMENT_QUESTIONS_API);
};

masterApis.getRMSRiskProfiles = () => {
  return axios.get(masterConstants.RMS_RISK_PROFILES_API);
};

masterApis.getStockList = () => {
  let queryParam = `?search=${""}`;
  return axios.get(`${masterConstants.RMS_FETCH_STOCKS}${queryParam}`);
};

masterApis.verfyAutoKYC = ({ dateOfBirth, pan }) => {
  return axios.post(masterConstants.VERIFY_AUTO_KYC_API, {
    dateOfBirth,
    pan,
  });
};

masterApis.verifyKycDocument = ({
  panCard,
  panCard_fileName,
  aadharCardFront,
  aadharCardFront_fileName,
  aadharCardBack,
  aadharCardBack_fileName,
  productCode,
  name,
  panNumber,
  aadhaarNumber,
  dateOfBirth,
}) => {
  const fd = new FormData();
  if (panCard && panCard_fileName) {
    fd.append("panCard", panCard, panCard_fileName);
  }

  if (aadharCardFront && aadharCardFront_fileName) {
    fd.append("aadharCardFront", aadharCardFront, aadharCardFront_fileName);
  }

  if (aadharCardBack && aadharCardBack_fileName) {
    fd.append("aadharCardBack", aadharCardBack, aadharCardBack_fileName);
  }
  fd.append("productCode", productCode);
  if (name) {
    fd.append("name", name);
  }
  if (panNumber) {
    fd.append("panNumber", panNumber);
  }
  if (aadhaarNumber) {
    fd.append("aadhaarNumber", aadhaarNumber);
  }
  if (dateOfBirth) {
    fd.append("dateOfBirth", dateOfBirth);
  }
  return axios.post(masterConstants.VERIFY_KYC_DOCUMENT_V2_API, fd);
};

masterApis.verifyManualKyc = ({
  dateOfBirth,
  panNumber,
  aadhaarNumber,
  productCode,
}) => {
  return axios.post(masterConstants.VERIFY_MANUAL_KYC_API, {
    dateOfBirth,
    panNumber,
    aadhaarNumber,
    productCode,
  });
};

masterApis.getMasterBrokers = ({
  isFetchHoldingEnabled,
  isIntegrated,
  searchTerm,
  productCode,
} = {}) => {
  const params = {};

  if (searchTerm) {
    params["search"] = searchTerm;
  }

  if (![null, undefined].includes(isIntegrated)) {
    params["isIntegrated"] = isIntegrated;
  }

  if (![null, undefined].includes(isFetchHoldingEnabled)) {
    params["isFetchHoldingEnabled"] = isFetchHoldingEnabled;
  }

  if (productCode) {
    params["productCode"] = productCode;
  }

  return axios.get(masterConstants.MASTER_BROKER_API, { params });
};

// masterApis.getOnestockMasterBrokers = ({ isFetchHoldingEnabled, isIntegrated, searchTerm, productCode } = {}) => {
//     const params = {};

//     if (searchTerm) {
//         params["search"] = searchTerm;
//     }

//     if (![null, undefined].includes(isIntegrated)) {
//         params["isIntegrated"] = isIntegrated;
//     }

//     if (![null, undefined].includes(isFetchHoldingEnabled)) {
//         params["isFetchHoldingEnabled"] = isFetchHoldingEnabled;
//     }

//     if (productCode) {
//         params["productCode"] = productCode;
//     }

//     return axios.get(masterConstants.ONESTOCK_MASTER_BROKER_API, { params });
// }

masterApis.validateOffer = ({
  offerCode,
  productCode,
  planId,
  offerType,
  customerValueAddedPlanId,
}) => {
  return axios.post(masterConstants.VALIDATE_OFFER_API, {
    offerCode,
    productCode,
    planId,
    offerType,
    ...(customerValueAddedPlanId ? { customerValueAddedPlanId } : {}),
  });
};

masterApis.updateLastActiveProduct = ({ productCode } = {}) => {
  if (!productCode) {
    productCode = localStore.getActiveProduct();
    localStore.resetActiveProduct();
  }
  return axios.post(masterConstants.UPDATE_LAST_ACTIVE_PRODUCT_API, {
    productCode,
  });
};

masterApis.getAppliedCampaignOffer = ({
  productCode,
  planId,
  offerType,
  customerValueAddedPlanId,
}) => {
  return axiosNT.post(masterConstants.APPLIED_CAMPAIGN_OFFER_API, {
    productCode,
    planId,
    offerType,
    ...(customerValueAddedPlanId ? { customerValueAddedPlanId } : {}),
  });
};

masterApis.getPaymentOfferBanner = ({ productCode, planId }) => {
  const params = { productCode };
  if (planId) {
    params.planId = planId;
  }
  return axiosNT.get(masterConstants.PAYMENT_OFFER_BANNER_API, { params });
};

masterApis.getPendingCall = () => {
  return axios.get(masterConstants.PENDING_CALL_API);
};

masterApis.fetchPlanDiscountedPriceOnUpgrade = async ({
  planId = "",
  productCode = "",
  investMoreAmount = "",
}) => {
  const headers = {
    "Content-Type": "application/json",
  };
  let payload = {
    newPlanId: planId,
    productCode,
  };
  if (investMoreAmount) {
    payload.investMoreAmount = investMoreAmount;
  }
  payload = JSON.stringify(payload);
  return await axios.post(masterConstants.UPGRADTION_AMOUNT_API, payload, {
    headers,
  });
};

// aadhar card verify
masterApis.getOtpAadharKYCApi = ({ aadhaarNumber }) => {
  return axios.post(masterConstants.AADHAR_GET_OTP, { aadhaarNumber });
};

// GET_KYC_COUNT
masterApis.getCountKyc = () => {
  return axios.get(masterConstants.GET_KYC_COUNT);
};

masterApis.countRemainingKyc = () => {
  return axios.get(masterConstants.VERIFY_KYC_COUNT);
};

masterApis.verfyOtpAadharKYCApi = (objectData) => {
  return axios.post(masterConstants.AADHAR_VERIFY_OTP, objectData);
};

masterApis.submitKYCApi = (productCode) => {
  return axios.post(masterConstants.SUMBIT_KYC, productCode);
};

// SENTIMENT
masterApis.getStatusCheck = () => {
  return axios.get(masterConstants.STATUS_CHECK);
};
masterApis.getValidateToken = () => {
  return axios.post(masterConstants.VALIDATE_TOKEN);
};

// FEEDBACK QUESTIONS API
masterApis.getFeedbackQuestions = () => {
  return axios.get("/review/get-review-questions");
};

// SUBMIT FEEDBACK API
masterApis.submitFeedback = (payload) => {
  return axios.post("/review/submit-review-status", payload);
};

// Call Schedule Api
masterApis.submitScheduleCall = (payload) => {
  return axios.post("/review/submit-schedule", payload);
};

// ticker Api
masterApis.getStockTicker = () => {
  return axios.get("/master/ticker");
};

masterApis.getNaviaCustomer = async (token, actId) => {
  const response = await fetch(
    `${config.apiUrl}/phc/health-check/navia-customer`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",

        sessionId: token,
        actId: String(actId),
      },
    },
  );

  if (!response.ok) {
    console.error(`API failed with status ${response.status}`);
  }

  const text = await response.text();

  // If response is empty
  if (!text) return null;

  // Try parsing JSON safely
  try {
    return JSON.parse(text);
  } catch (e) {
    console.error("Navia API returned non-JSON:", text);
    return null;
  }
};

masterApis.getCouponList = (productCode) => {
  return axios.get(`master/display-coupons?productCode=${productCode}`);
};

export { masterApis };
